<div
  bsModal
  #listOwnersEditorModal="bs-modal"
  [config]="{
    show: false,
    keyboard: listOwnersEditorState && !listOwnersEditorState.isSaving,
    ignoreBackdropClick: listOwnersEditorState?.isSaving
  }"
  [rlTrapFocus]="focusTrapConfig"
  (onHidden)="onHide()"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="list-owners-editor-modal"
  aria-hidden="true"
>
  <div class="modal-dialog qa-list-owners-editor-modal-dialog">
    <div class="modal-content" *ngIf="listOwnersEditorState?.isModalShown">
      <div class="modal-header">
        <h2
          class="modal-title"
          id="list-owners-editor-modal"
          i18n="@@listOwnersEditorModal-heading-assignListOwner"
        >
          Assign list owner
        </h2>
      </div>

      <rl-list-owners-editor
        *ngIf="listOwnersEditorState ? true : false"
        [currentUser]="currentUser"
        [listOwnersEditorState]="listOwnersEditorState"
        [listOwners]="listOwners"
        (close)="onHide()"
        (save)="onSave($event)"
      >
      </rl-list-owners-editor>
    </div>
  </div>
</div>
